/**
 * wql
 * @description 审批作业
 * @Date 2021/02/04
 */
import React from 'react'
import {component_tool, framework_tool} from '../../../tool';
import {WizTableForm} from '../../common'
import { getLocationOrgin } from '@/utils/commonUtils';
import './index.less'

const organizationConfig = WizTableForm.Config.organizationByNoFilter(this, {apiParams: {state: 1}})
const positionConfig = WizTableForm.Config.positionByNoFilter(this, {apiParams: {state: 1}})
const labelConfig = WizTableForm.Config.label(this, {apiParams: {type: 12}})

let {WizRow, WizCol, WizCheckbox, WizTag, WizInput, WizInputNumber, WizRadio,WizModal} = component_tool;

this.batchAuditRecord = (record, onDo) => {
  onDo.doAction({
    path: 'homeworkRecord/batchAudit',
    payload: {
      key: 'homeworkRecord@batchAudit',
      apiParams: {
        auditCmds: record
      }
    }
  })
}


//配置项
let componentName = 'homeworkRecord'
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "标题",
    name: "name",
    dataIndex: "name",
    searchItem: {},
    tableItem: {}
  },
  {
    title: "提交人姓名",
    name: "fullName",
    dataIndex: "fullName",
    searchItem: {},
    tableItem: {}
  },
  {
    title: "提交人账号",
    name: "userName",
    dataIndex: "userName",
    searchItem: {},
    tableItem: {}
  },
  {
    title: "组织",
    name: "orgId",
    searchItem: {
      diy: WizTableForm,
      ...organizationConfig,
      selectType: 'radio',
    }
  },
  {
    title: "组织名称",
    name: "orgName",
    dataIndex: "orgName",
    tableItem: {}
  },
  {
    title: "组织编码",
    name: "orgCode",
    dataIndex: "orgCode",
    tableItem: {}
  },
  {
    title: "岗位",
    name: "positionId",
    searchItem: {
      diy: WizTableForm,
      ...positionConfig,
      selectType: 'radio',
    }
  },
  {
    title: "岗位",
    name: "positionName",
    dataIndex: "positionName",
    tableItem: {}
  },
  {
    title: "是否通过",
    name: "pass",
    dataIndex: "pass",
    tableItem: {},
    searchItem: {
      type: 'select',
    },
    dict: [
      {code: 0, codeName: "未通过"},
      {code: 1, codeName: "通过"},
    ],
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    searchItem: {
      type: 'select',
    },
    dict: [
      {code: 0, codeName: "未提交"},
      {code: 1, codeName: "已提交"},
      {code: 2, codeName: "已批阅"},
      {code: 3, codeName: "已撤回"},
      {code: 4, codeName: "批阅中"},
    ],
  },
  {
    title: "标签",
    name: "labelIds",
    dataIndex: "labelIds",
    searchItem: {
      ...labelConfig,
      diy: WizTableForm,
      selectType: 'radio',
    }
  },
  {
    title: "标签",
    name: "labelIds",
    dataIndex: "labelIds",
    width: 150,
    tableItem: {}
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      {code: 0, codeName: "未提交"},
      {code: 1, codeName: "已提交"},
      {code: 2, codeName: "已批阅"},
      {code: 3, codeName: "已撤回"},
      {code: 4, codeName: "批阅中"},
    ],
  },
  {
    title: "成绩",
    name: "score",
    dataIndex: "score",
    width: 150,
    tableItem: {},
  },
  {
    title: "评分人",
    name: "reviewerName",
    dataIndex: "reviewerName",
    tableItem: {}
  },
  {
    title: "当前评分人",
    name: "currentReviewerName",
    dataIndex: "currentReviewerName",
    tableItem: {}
  }
];

const templateConfig = (data) => {
  const {_this, labelAll} = data;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          buttonSort: ['export', 'batchReview','open','close'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            },
            {
              key: 'open',
              custom: true,
              params: {children: '标记批阅中'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "updateState",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  let ids =[];
                  rows && rows.length && rows.forEach(e => {
                    ids.push(e.id)
                  })
                  // return {...filters,ids,state:4}
                  let title = <div>
                    <div>确认将选中的作业记录标记为批阅中？</div>
                    <div style={{marginTop:"10px",fontSize:"14px"}}>注：标记批阅中后，请半小时后前往OSS中下载作业。</div>
                  </div>
                  WizModal.confirm({
                    title: title,
                    onOk: () => {
                      callback && callback({
                        ids,state:4
                      })
                    },
                    onCancel() { }
                  });
                  return null
                }
              },
              recordChangeParams: ({record, rows}) => {
                let disabled = true;
                if(rows.length){
                  disabled = false;
                }
                rows && rows.length && rows.some(e => {
                  if (e.state!= 1) {
                    return disabled = true
                  }
                })
                return {disabled}
              }
            },
            {
              key: 'close',
              custom: true,
              params: {children: '取消标记'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "updateState",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  let ids = [];
                  rows && rows.length && rows.forEach(e => {
                    ids.push(e.id)
                  })
                  return {...filters,ids,state:1}
                }
              },
              recordChangeParams: ({record, rows}) => {
                let disabled = true;
                if(rows.length){
                  disabled = false;
                }
                rows && rows.length && rows.some(e => {
                  if (e.state != 4) {
                    return disabled = true
                  }
                })
                return {disabled}
              }
            },
            {
              key: 'batchReview',
              custom: true,
              params: {children: '批量批阅'},
              needSelect: true,
              customOnClick: {
                key: 'modal',
                params: {
                  modalParams: {
                    title: '批量批阅',
                    destroyOnClose: true,
                    width: 700,
                    centered: true,
                    diy: (e) => {
                      _this.changeModal = e.changeModal
                      let record = e && e.rows
                      _this.setState({record:record})
                      let initialValue = record && Array.isArray(record) && record.find(e => e.id > 0);
                      return <>
                        <div className="batchReviewModal">
                          <WizRow className="modal-row">
                            <WizCol span={4} className="modal-col" >考分提示：</WizCol>
                            <WizCol span={15} className="modal-col-right">
                              {initialValue && initialValue.totalScore && initialValue.totalScore > 0 ? (
                                <WizTag className="modal-col-tag-total">{'满分' + initialValue.totalScore + '分'}</WizTag>) : ''}
                              {initialValue && initialValue.passScore && initialValue.passScore > 0 ? (
                                <WizTag className="modal-col-tag-pass">{'及格' + initialValue.passScore + '分'}</WizTag>) : ''}
                            </WizCol>
                          </WizRow>
                          <WizRow className="modal-row">
                            <WizCol span={4} className="modal-col">成绩：</WizCol>
                            <WizCol span={15} className="modal-col-right">
                              <WizInputNumber min={0} max={99999.5} placeholder="请输入学员成绩" style={{ 'width': '200px' }}
                                              onChange={(score) => { _this.setState({ score: score }) }}/>
                            </WizCol>
                          </WizRow>
                          <WizRow className="modal-row">
                            <WizCol span={4} className="modal-col">
                              <span><font style={{'color':'red'}}>*</font> 评语：</span>
                            </WizCol>
                            <WizCol span={15} className="modal-col-right">
                              <WizInput.TextArea maxLength={300} rows={4} onChange={(e) => {_this.setState({comment: e.target.value})}}/>
                            </WizCol>
                          </WizRow>
                          <WizRow className="modal-row">
                            <WizCol span={4} className="modal-col">
                              <span><font style={{'color':'red'}}>*</font> 是否通过：</span>
                            </WizCol>
                            <WizCol span={15} className="modal-col-right">
                              <WizRadio.Group defaultValue={1} onChange={(e) => { _this.setState({pass: e.target.value})}}>
                                <WizRadio value={1}>通过</WizRadio>
                                <WizRadio value={0}>未通过</WizRadio>
                              </WizRadio.Group>
                            </WizCol>
                          </WizRow>
                          <WizRow className="modal-row">
                            <WizCol span={4} className="modal-col">标签：</WizCol>
                            <WizCol>
                              <WizCheckbox.Group onChange={(e) => { _this.setState({labelIds: e})}}>
                                {labelAll && Array.isArray(labelAll) && labelAll.map(label => {
                                  return (
                                    <WizCheckbox value={label.id}>{label.title}</WizCheckbox>
                                  )
                                })}
                              </WizCheckbox.Group>
                            </WizCol>
                          </WizRow>
                        </div>
                      </>
                    },
                    onOk: (e) => {
                      let passArr = [0,1]
                      let {record,comment, score, pass,labelIds} = _this.state
                      if (!comment) {
                        wizNotice.error("评语不能为空")
                        return false
                      }
                      if (passArr.indexOf(pass) == -1) {
                        pass = 1
                      }
                      let params = []
                      record && Array.isArray(record) && record.map(r => {
                        r.comment = comment
                        r.score = score
                        r.pass = pass
                        r.labelIds = labelIds && labelIds.join(',')
                        params.push(r)
                      })
                      this.batchAuditRecord(params,_this)
                      _this.setState({record:null,comment:null, score:null, pass:1,labelIds:[]})
                    },
                    onCancel: () => {
                      _this.setState({record:null,comment:null, score:null, pass:1,labelIds:[]})
                    }
                  }
                }
              },
              recordChangeParams: ({record, rows}) => {
                let homeworkIds = new Set();
                rows && rows.length && rows.forEach(e => {
                  homeworkIds.add(e.homeworkId)
                })
                let disabled = true;
                if (homeworkIds && homeworkIds.size == 1) {
                  disabled = false
                }
                rows && rows.length && rows.some(e => {
                  if (e.state === 0 || e.state===3) {
                    return disabled = true
                  }
                })
                return {disabled}
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['look', 'correction', 'homeworkReviewDownload'],
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: {children: "查看"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "openUrl"
              },
              formatParams: (rows, record, filters, callback) => {
                let id = record.id;
                let url = getLocationOrgin() + '/#/homeworkRecord/homeworkRecordShow?id=' + id
                window.open(url, '_blank')
                return null
              }
            },
            recordChangeParams: ({record, rows}) => {
              return {disabled: record.state === 0}
            }
            //     // window.open(location.origin + `/#/schedule/study?pid=${detail['id']}&sid=${id}`, id)
            //     window.open(location.origin + `/#/homeworkRecord/homeworkRecordShow?id=${id}`, id);
          },
          {
            key: "correction",
            custom: true,
            params: {children: "批阅"},
            textFormat: {
              recordKey: 'pass',
              dirt: {null: '批阅', 1: '复批', 0: '复批'}
            },
            recordChangeParams: ({record, rows}) => {
              return {disabled: record.state === 0 || record.state ===3 }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "check",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return {id: record.id}
              },
            }
          },
          {
            key: "homeworkReviewDownload",
            custom: true,
            params: {children: "批量下载"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "getInfo",
                apiParams: {}
              },
            },
            recordChangeParams: ({record, rows}) => {
              return {disabled: record.state === 0}
            },
          }
        ]
      }
    }
  };
}

let reduxTemplateCofig = (args) => {
  const {entityId} = args;
  const apis = {
    list: {
      path: `${componentName}/getReviewPageList`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/exportReview`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {}
      }
    },
    check: {
      path: `${componentName}/reviewCheck`,
      payload: {
        key: `${componentName}@checkHandler`,
        apiParams: {}
      }
    },
    getInfo: {
      path: `${componentName}/getInfo`,
      payload: {
        key: `${componentName}@getInfo`,
        apiParams: {}
      }
    },
    batchAudit: {
      path: `homeworkRecord/batchAudit`,
      payload: {
        key: `homeworkRecord@batchAudit`,
        apiParams: {}
      }
    },
    updateState:{
      path: `homeworkRecord/updateState`,
      payload: {
        key: `homeworkRecord@updateState`,
        apiParams: {}
      }
    }
  }
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
